import React from 'react';
import {Composition} from 'remotion';
import {DURATION, Film} from './Film';
import {DURATION as DURATION_CAPTURA, Film as FilmCaptura} from './FilmCaptura';
import {FPS} from './theme';
import {CLOSING_S, Closing, OPENING_S, Opening} from './Cards';

// Both cuts of the landing-page demo, each in pt and en (locale prop), in one Studio: the UI rebuilt in code, and the real stage app captured
// (FilmCaptura.tsx is the motion-capturado timeline, kept here so motion.euzebio.me shows both side by side).
export const Root: React.FC = () => <>
 <Composition id="Demo-GroupFaces" component={Film} defaultProps={{locale: 'pt' as const}} width={1920} height={1080} fps={FPS} durationInFrames={Math.round(DURATION * FPS)}/>
 <Composition id="Demo-GroupFaces-EN" component={Film} defaultProps={{locale: 'en' as const}} width={1920} height={1080} fps={FPS} durationInFrames={Math.round(DURATION * FPS)}/>
 <Composition id="Demo-GroupFaces-Captura" component={FilmCaptura} defaultProps={{locale: 'pt' as const}} width={1920} height={1080} fps={FPS} durationInFrames={Math.round(DURATION_CAPTURA * FPS)}/>
 <Composition id="Demo-GroupFaces-Captura-EN" component={FilmCaptura} defaultProps={{locale: 'en' as const}} width={1920} height={1080} fps={FPS} durationInFrames={Math.round(DURATION_CAPTURA * FPS)}/>
 {/* standard tutorial opening/closing, for approval (Cards.tsx); one closing per candidate line */}
 <Composition id="Tutorial-Abertura" component={Opening} defaultProps={{index: 1, total: 3, title: 'Do upload à entrega'}} width={1920} height={1080} fps={FPS} durationInFrames={Math.round(OPENING_S * FPS)}/>
 <Composition id="Tutorial-Fechamento-A" component={Closing} defaultProps={{line: ['Milhares de fotos. ', 'Cada rosto na sua galeria.'] as [string, string]}} width={1920} height={1080} fps={FPS} durationInFrames={Math.round(CLOSING_S * FPS)}/>
 <Composition id="Tutorial-Fechamento-B" component={Closing} defaultProps={{line: ['Cada pessoa, ', 'todas as suas fotos.'] as [string, string]}} width={1920} height={1080} fps={FPS} durationInFrames={Math.round(CLOSING_S * FPS)}/>
 <Composition id="Tutorial-Fechamento-C" component={Closing} defaultProps={{line: ['Fotos separadas por rosto. ', 'Automaticamente.'] as [string, string]}} width={1920} height={1080} fps={FPS} durationInFrames={Math.round(CLOSING_S * FPS)}/>
 <Composition id="Tutorial-Fechamento-D" component={Closing} defaultProps={{line: ['Encontre cada pessoa ', 'em cada foto.'] as [string, string]}} width={1920} height={1080} fps={FPS} durationInFrames={Math.round(CLOSING_S * FPS)}/>
 <Composition id="Tutorial-Fechamento-E" component={Closing} defaultProps={{line: ['Do evento inteiro ', 'às fotos de cada um.'] as [string, string]}} width={1920} height={1080} fps={FPS} durationInFrames={Math.round(CLOSING_S * FPS)}/>
</>;

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
